/**
 * Footer Component - Landing Page
 */

import React from 'react';
import { Heart } from 'lucide-react';
import BRANDING from '../../../../config/branding';

const Footer = ({ language }) => {
  const isArabic = language === 'ar';
  const currentYear = new Date().getFullYear();

  return (
    <footer className="w-full bg-[#0B0E14] border-t border-[#2D3748] py-12 sm:py-16 md:py-20 lg:py-24 px-3 sm:px-4 relative">
      {/* Background accent */}
      <div className="absolute inset-0 bg-gradient-to-b from-[#128C7E]/5 via-transparent to-transparent pointer-events-none" />
      
      <div className="relative max-w-6xl mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-8 sm:gap-10 md:gap-12 mb-12 sm:mb-16">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <img
                src={BRANDING.favicon}
                alt="logo"
                className="w-6 h-6 sm:w-8 sm:h-8"
              />
              <h3 className="text-base sm:text-lg font-bold text-white">
                {BRANDING[language]}
              </h3>
            </div>
            <p className="text-[#A0AEC0] text-xs sm:text-sm leading-relaxed">
              {isArabic
                ? 'منصة OTP موثوقة وآمنة وسهلة الاستخدام'
                : 'Reliable, secure, and easy-to-use OTP platform'}
            </p>
          </div>

          {/* Product */}
          <div>
            <h4 className="text-white font-semibold mb-4 sm:mb-6 text-sm sm:text-base">
              {isArabic ? 'المنتج' : 'Product'}
            </h4>
            <ul className="space-y-2 sm:space-y-3 text-[#A0AEC0] text-xs sm:text-sm">
              <li>
                <a href="#features" className="hover:text-[#128C7E] transition-colors">
                  {isArabic ? 'المميزات' : 'Features'}
                </a>
              </li>
              <li>
                <a href="#pricing" className="hover:text-[#128C7E] transition-colors">
                  {isArabic ? 'الأسعار' : 'Pricing'}
                </a>
              </li>
              <li>
                <a href="#api" className="hover:text-[#128C7E] transition-colors">
                  API
                </a>
              </li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="text-white font-semibold mb-4 sm:mb-6 text-sm sm:text-base">
              {isArabic ? 'الشركة' : 'Company'}
            </h4>
            <ul className="space-y-2 sm:space-y-3 text-[#A0AEC0] text-xs sm:text-sm">
              <li>
                <a href="#about" className="hover:text-[#128C7E] transition-colors">
                  {isArabic ? 'عن' : 'About'}
                </a>
              </li>
              <li>
                <a href="#contact" className="hover:text-white transition-colors">
                  {isArabic ? 'تواصل' : 'Contact'}
                </a>
              </li>
              <li>
                <a href="/privacy-policy" className="hover:text-white transition-colors">
                  {isArabic ? 'الخصوصية' : 'Privacy'}
                </a>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="text-white font-semibold mb-4 sm:mb-6 text-sm sm:text-base">
              {isArabic ? 'قانوني' : 'Legal'}
            </h4>
            <ul className="space-y-2 text-[#A0AEC0] text-xs sm:text-sm">
              <li>
                <a href="#terms" className="hover:text-white transition-colors">
                  {isArabic ? 'الشروط' : 'Terms'}
                </a>
              </li>
              <li>
                <a href="/privacy-policy" className="hover:text-white transition-colors">
                  {isArabic ? 'السياسة' : 'Policy'}
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-[#2D3748] pt-6 sm:pt-8 flex flex-col sm:flex-row justify-between items-center gap-3 sm:gap-4 text-center sm:text-left">
          <p className="text-[#718096] text-xs sm:text-sm">
            {isArabic ? '©' : '©'} {currentYear}{' '}
            {BRANDING[language]}. {isArabic ? 'جميع الحقوق محفوظة' : 'All rights reserved'}.
          </p>
          <p className="text-[#718096] text-xs sm:text-sm flex items-center gap-1">
            {isArabic ? 'مصنوع بـ' : 'Made with'}{' '}
            <Heart className="w-3 h-3 sm:w-4 sm:h-4 text-[#128C7E]" />{' '}
            {isArabic ? 'بواسطة الفريق' : 'by the team'}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
